import src from "IMAGE";
export default { src, width: 464, height: 128, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42l3IsQ0AERQA0L/AxRWXXIiIQqK1g0a0VrKB0KhVJpDYgoE0NF75ADYqqTIlTJt8/wnicEMMC1fz0NG393vI+QVgxgqaT6ynSAAAAABJRU5ErkJggg=="};
